export default __webpack_public_path__ + "static/media/pw-dashboard.48e98fbe.jpg";